import { render } from "./UserAdd.vue?vue&type=template&id=12a1d189"
import script from "./UserAdd.vue?vue&type=script&lang=js"
export * from "./UserAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__